/* V166 · Collection grid "After Dark · Daylight": the full-width Add to cart button
   runs the card's existing quick add (same popup / add as the old + button).
   No quick add on the card (setting off) -> it opens the product page. */
(function () {
  'use strict';
  if (window.__gobd34) return; window.__gobd34 = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gobd34-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('.grid-product');
    var q = card && card.querySelector('.quick-add-btn');
    if (q) q.click(); else if (b.getAttribute('data-url')) location.href = b.getAttribute('data-url');
  });
})();

(() => {
  let observer;
  function bindCollectionViews() {
    if (!document.body.classList.contains('template-collection')) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('view') === 'list') {
      url.searchParams.delete('view');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
    const root = document.getElementById('CollectionAjaxResult');
    if (!root) return;
    const normalize = () => {
      root.querySelectorAll('.product-grid[data-view="list"]').forEach(grid => {
        grid.dataset.view = 'medium';
        const wrapper = grid.closest('.collection-grid__wrapper');
        wrapper?.querySelectorAll('.grid-view-btn').forEach(button => button.classList.toggle('is-active', button.dataset.view === 'medium'));
      });
    };
    normalize();
    observer?.disconnect();
    observer = new MutationObserver(normalize);
    observer.observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['data-view']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindCollectionViews, {once: true});
  else bindCollectionViews();
  document.addEventListener('shopify:section:load', bindCollectionViews);
  window.addEventListener('pageshow', bindCollectionViews);
  window.addEventListener('popstate', bindCollectionViews);
})();
